import { ColorEnum } from '@/constants/color'
import { animationDurationMs } from '@/features/pos/components/ProductConfigurationModal/parts/OptionGroup/parts/OptionItem/constants'
import {
    Easing,
    interpolate,
    interpolateColor,
    useAnimatedReaction,
    useAnimatedStyle,
    useSharedValue,
    withTiming,
} from 'react-native-reanimated'

interface SelectedColors {
    backgroundColor: ColorEnum
    borderColor: ColorEnum
}

export const useAnimatedContainerStyle = (selected: boolean, selectedColors: SelectedColors) => {
    const progress = useSharedValue(0)

    useAnimatedReaction(
        () => selected,
        () => {
            progress.value = withTiming(selected ? 1 : 0, {
                duration: animationDurationMs,
                easing: Easing.out(Easing.linear),
            })
        }
    )

    return useAnimatedStyle(() => {
        const backgroundColor = interpolateColor(
            progress.value,
            [0, 1],
            [ColorEnum.WHITE, selectedColors.backgroundColor]
        )
        const borderColor = interpolateColor(
            progress.value,
            [0, 1],
            [ColorEnum.GRAY_300, selectedColors.borderColor]
        )
        const borderWidth = interpolate(progress.value, [0, 1], [1, 2])

        return { backgroundColor, borderColor, borderWidth }
    })
}
